import React, { useState } from 'react'
import './styles/MainForm.scss'
import { useLocation } from 'react-router-dom' // Импортируем хук useLocation

import imageForm from '../images/imageForm.svg'

import axios from 'axios'
import ReactInputMask from 'react-input-mask'

function MainForm() {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        organization: '',
    })

    
    const location = useLocation() // Получаем текущий путь страницы

    const message = `<b>Новая заявка от</b> ${formData.name}%0A<b>Номер телефона:</b> ${formData.phone}%0A<b>Название организации:</b> ${formData.organization}%0A<b>Отправлено со страницы:</b> ${location.pathname}`
    const chatID = '-4158468542'
    const botToken = '6762434307:AAHcGMIo4DnOYdONpSAAVGIWuxaqKQuGCoY'

    const handleChange = (event) => {
        const { name, value } = event.target
        setFormData({
            ...formData,
            [name]: value,
        })
    }

    const handlePhoneChange = (event) => {
        const { name, value } = event.target
        setFormData({
            ...formData,
            [name]: value,
            page: location.pathname,
        })
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        // console.log(formData) 

        const botUrl = `https://api.telegram.org/bot${botToken}/sendMessage?chat_id=${chatID}&parse_mode=html&text=${message}`
        axios.post(botUrl, formData.name).then((response) => console.log(response))
        setFormData({
            name: '',
            phone: '',
            organization: '',
        })
      
    }

    return (
        <form className="main-form added-shadow added-shadow--var1 added-border added-border--vertical" onSubmit={handleSubmit}>
            <img src={imageForm} alt="" />
            <br />
            <h3 className="align-center">Форма обратной связи</h3>
            <div className="main-text align-center">Оставьте свойства номер телефона и мы с вами свяжемся в ближайшее время.</div>
            <br />
            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Имя" />

            <ReactInputMask
                mask="+7 (999) 999-99-99"
                maskChar="_"
                name="phone"
                onChange={handlePhoneChange}
                placeholder="+7 (___) ___-__-__"
                value={formData.phone}
            />

            <input type="text" name="organization" value={formData.organization} onChange={handleChange} placeholder="Организация" />
            <br />

            <button type="submit" className="btn btn--blue btn--width-full">
                Свяжитесь со мной
            </button>
        </form>
    )
}

export default MainForm
